{
	"isGrouped": "Il existe des produits sans prix enregistré",
	"isNotGrouped": "Prix non enregistré",
	"na": "N/A"
}
